import React from "react";
import { FC } from "react";
import { Theme } from "@material-ui/core";
import FontIcon from "../../../../components/FontIcon";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import makeStyles from "@material-ui/core/styles/makeStyles";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import { Routes } from "../../../../constants/routes";
import { useAuth } from "../../../auth/hooks/useAuth";
import { AdapterLink } from "../../../../components/Adopter";
import { EducationType } from "../../../school/constants/types";
import { UserRole } from "../../../user/enums/UserRole";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
  },
  link: {
    "&.active": {
      textDecoration: "none",
      color: theme.palette.secondary.light,
    },
  },
}));

const DashboardBottomMenu: FC = () => {
  const { user } = useAuth();

  if (!user) return null;

  switch (user.role) {
    case UserRole.Agent:
      return <AgentBottomMenu />;
    case UserRole.School:
      return <SchoolBottomMenu />;
    case UserRole.ServiceProvider:
      return <ServiceProviderBottomMenu />;
    case UserRole.Student:
      return <StudentBottomMenu />;
    default:
      return null;
  }
};

const AgentBottomMenu: FC = () => {
  const classes = useStyles();
  //TODO: AH replace icon for private classes
  return (
    <BottomNavigation showLabels className={classes.root}>
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${Routes.PROGRAMS}`}
        label="Programs"
        className={classes.link}
        icon={<FontIcon name={"service-online-courses"} fontSize={"small"} />}
      />
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${Routes.PRIVATE_CLASSES}`}
        label="Private Classes"
        className={classes.link}
        icon={<FontIcon name={"service-online-courses"} fontSize={"small"} />}
      />
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${Routes.SERVICE_LIST}`}
        label="Services"
        className={classes.link}
        icon={<FontIcon name={"service-online-courses"} fontSize={"small"} />}
      />
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${Routes.STUDENTS}`}
        className={classes.link}
        label="Students"
        icon={<FontIcon name={"student"} fontSize={"small"} />}
      />
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${Routes.BILLING}`}
        label="Billing"
        className={classes.link}
        icon={<FontIcon name={"money"} fontSize={"small"} />}
      />
      <BottomNavigationAction
        component={AdapterLink}
        href={Routes.AGENT_GUIDE}
        target="_blank"
        className={classes.link}
        label="Help"
        icon={<FontIcon name={"question"} fontSize={"small"} />}
      />
    </BottomNavigation>
  );
};
const StudentBottomMenu: FC = () => {
  const classes = useStyles();
  //TODO: AH replace icon for private classes
  return (
    <BottomNavigation showLabels className={classes.root}>
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${Routes.PROGRAMS}`}
        label="Programs"
        className={classes.link}
        icon={<FontIcon name={"service-online-courses"} fontSize={"small"} />}
      />
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${Routes.PRIVATE_CLASSES}`}
        label="Private Classes"
        className={classes.link}
        icon={<FontIcon name={"service-online-courses"} fontSize={"small"} />}
      />
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${Routes.SERVICE_LIST}`}
        label="Services"
        className={classes.link}
        icon={<FontIcon name={"service-online-courses"} fontSize={"small"} />}
      />
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${Routes.APPLICATIONS}`}
        label="Applications"
        className={classes.link}
        icon={<FontIcon name={"calendar"} fontSize={"small"} />}
      />
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${Routes.BILLING}`}
        label="Billing"
        className={classes.link}
        icon={<FontIcon name={"money"} fontSize={"small"} />}
      />
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${Routes.MESSAGES}`}
        className={classes.link}
        label="Messages"
        icon={<FontIcon name={"message"} fontSize={"small"} />}
      />
    </BottomNavigation>
  );
};
const SchoolBottomMenu: FC = () => {
  const classes = useStyles();
  const { profile } = useAuth();

  const schoolTypeId = profile?.data?.data?.school?.type?.id;

  return (
    <BottomNavigation showLabels className={classes.root}>
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${Routes.BRANCHES}`}
        className={classes.link}
        label="Branches"
        icon={<FontIcon name={"school"} fontSize={"small"} />}
      />
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${
          schoolTypeId === EducationType.Language
            ? Routes.LANGUAGE_COURSES
            : Routes.ACADEMICS
        }`}
        className={classes.link}
        label={
          schoolTypeId === EducationType.Language ? "Courses" : "Academics"
        }
        icon={<FontIcon name={"home"} fontSize={"small"} />}
      />
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${Routes.STUDENTS}`}
        className={classes.link}
        label="Students"
        icon={<FontIcon name={"student"} fontSize={"small"} />}
      />
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${Routes.BILLING}`}
        label="Billing"
        className={classes.link}
        icon={<FontIcon name={"money"} fontSize={"small"} />}
      />
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${Routes.MESSAGES}`}
        className={classes.link}
        label="Messages"
        icon={<FontIcon name={"message"} fontSize={"small"} />}
      />
      <BottomNavigationAction
        component={AdapterLink}
        href={
          schoolTypeId === EducationType.Higher
            ? Routes.HIGHER_SCHOOL_GUIDE
            : Routes.SECONDARY_SCHOOL_GUIDE
        }
        target="_blank"
        className={classes.link}
        label="Help"
        icon={<FontIcon name={"question"} fontSize={"small"} />}
      />
    </BottomNavigation>
  );
};
const ServiceProviderBottomMenu: FC = () => {
  const classes = useStyles();

  return (
    <BottomNavigation showLabels className={classes.root}>
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${Routes.SERVICE_LIST}/management`}
        className={classes.link}
        label="Services"
        icon={<FontIcon name={"services"} fontSize={"small"} />}
      />
      <BottomNavigationAction
        component={AdapterLink}
        to={`/0/${Routes.MESSAGES}`}
        className={classes.link}
        label="Messages"
        icon={<FontIcon name={"message"} fontSize={"small"} />}
      />
    </BottomNavigation>
  );
};

export default React.memo(DashboardBottomMenu);
